module.exports = __webpack_public_path__ + "static/android-icon-192x192-8a261529ca59f23d7c501c2523d9980c.png";